import { DocumentSourceSelector } from '@/components/documentAgent/DocumentSourceSelector'
import type { DocumentSourceItem } from '@/components/documentAgent/DocumentSourceSelector'
import type { ComponentProps } from 'react'

export type ProposalSourceItem = DocumentSourceItem
type SelectorProps = ComponentProps<typeof DocumentSourceSelector>

export function ProposalDocumentSelector({
  emptyText = 'No .docx or .pdf workspace content found.',
  noSelectionText = 'The template document will be used as context.',
  searchPlaceholder = 'Search documents',
  ...props
}: SelectorProps) {
  return (
    <DocumentSourceSelector
      {...props}
      emptyText={emptyText}
      noSelectionText={noSelectionText}
      searchPlaceholder={searchPlaceholder}
    />
  )
}

export function ProposalSourceSelector(props: Omit<SelectorProps, 'selectionMode'>) {
  return <ProposalDocumentSelector {...props} selectionMode="multiple" />
}
